import(/* webpackMode: "eager" */ "/app/app/global-error.js")